export const brandTrackedDomainsPermission = {
    brandTrackedDomainsView: "brand-tracked-domains.get",
};
